import React from 'react';

const SummaryCard = ({ children, title = 'Summary' }) => (
  <aside className="legal-summary-card" aria-label={title}>
    <p className="legal-summary-card__label">{title}</p>
    <p className="legal-summary-card__text">{children}</p>
  </aside>
);

export default SummaryCard;
